import { MenuItem } from '../types';

export const MENU_ORDER = [
  MenuItem.General,
  MenuItem.Prepayments,
  MenuItem.Commodities,
  MenuItem.Forecast,
  MenuItem.Milestones,
];
